import { API_URLS } from '../../../constants/urls/api-urls';
import { LoyaltyActionType } from '../../../types/loyaltyAction';
import { delData, getData, postData, putData } from '../../../utils/fetch-api-util';

export interface GetVisibleTypeParams {
  country?: string;
  page?: number;
  take?: number;
}

export interface SetVisibleTypeParams {
  name: string;
  feature: string;
  annexActionId: string | number;
  countryCode?: string;
}

interface SuccessResponse {
  success: boolean;
}

export const getLoyaltyListRepository = async (url: string, params: GetVisibleTypeParams): Promise<any> => {
  const response = await getData<{}, {}>(url, params);
  return response?.data || [];
};

export const postCreateLoyaltyActionRepository = async (url: string, payload: SetVisibleTypeParams): Promise<void> => {
  await postData<SetVisibleTypeParams, LoyaltyActionType>(url, payload);
};

export const putUpdateLoyaltyActionRepository = async (url: string, payload: SetVisibleTypeParams): Promise<void> => {
  await putData<SetVisibleTypeParams, LoyaltyActionType>(url, payload);
};

export const deleteLoyaltyAction = async (id: string): Promise<void> => {
  await delData<SuccessResponse>(API_URLS.LOYALTY_ACTION_URL_WITH_ID(id));
};
